import React from "react";
import { Navbar, Container } from "react-bootstrap";
import { ReactComponent as LogoSVG } from "../assets/Bege_branco.svg";
import { ReactComponent as WhatsApp } from "../assets/whatsapp.svg";
import colors from "../utils/colors";

const styles = {
  phone: {
    fontSize: "1.1rem",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    width: "85%",
    textAlign: "center",
    selfAlign: "center",
  },
  span: {
    fontSize: "0.8rem",
  },
  icon: {
    paddingRight: "0px",
    width: "15%",
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "space-between",
    marginBottom: "5px",
  },
};

const ContactBox = (props) => {
  const { link, icon, phone, legend } = props;

  return (
    <a
      href={link}
      style={{ textDecoration: "none", color: "white" }}
      target="_blank"
    >
      <div className="">
        <div className="justify-content-center d-flex" style={styles.box}>
          <div className="" style={styles.icon}>
            {icon}
          </div>

          <div className="justify-content-center" style={styles.phone}>
            {phone}
          </div>
        </div>
        <div className="text-center" style={styles.span}>
          {legend}
        </div>
      </div>
    </a>
  );
};

function Header() {
  return (
    <Navbar
      className="header mb-5"
      style={{ height: "60px", backgroundColor: colors.darkblue }}
    >
      <Container>
        <Navbar.Brand href="#home" className="text-white">
          <LogoSVG
            className="float-start"
            style={{
              height: "80px",
              width: "auto",
            }}
          />
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Navbar.Text className="text-white text-center">
            Central de Pagamentos
          </Navbar.Text>
        </Navbar.Collapse>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text className="text-white text-center">
            <ContactBox
              icon={
                <WhatsApp
                  style={{
                    height: "30px",
                    width: "auto",
                    left: "0px",
                  }}
                  className="float-start"
                />
              }
              phone="(27) 9 8803 8225"
              legend="WhatsApp Exclusivo para Vendas"
              link="https://api.whatsapp.com/send?phone=5527988038225&text=Ola,%20gostaria%20de%20saber%20mais%20sobre%20os%20produtos%20da%20SHARMAQ%20sistemas."
            />
          </Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
